import {useContext} from 'react';

import dayjs from 'dayjs';

import {SxProps, useTheme} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';

import {LanguageContext} from '../../contexts/LanguageContext/LanguageContext';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/de';
import {orangeColors} from '../../layouts/theme/designSystem';
import {getFieldStyle} from '../../layouts/theme/FieldStyles';

interface Props {
  setFieldValue: (field: string, value: any) => void;
  name: string;
  value: string;
  label?: string;
  sx?: SxProps;
  size?: 'small' | 'medium';
  disabled?: boolean;
}

export const EmpionDatePicker = ({name, setFieldValue, value, label, size = 'medium', sx, disabled}: Props) => {
  const currentLanguage = useContext(LanguageContext);
  const isEnglish = currentLanguage === 'en';
  const theme = useTheme();
  const style = sx ? sx : getFieldStyle(theme);

  return (
    <LocalizationProvider
      localeText={{
        fieldDayPlaceholder: () => (isEnglish ? 'DD' : 'TT'),
        fieldYearPlaceholder: () => (isEnglish ? 'YYYY' : 'JJJJ'),
      }}
      dateAdapter={AdapterDayjs}
      adapterLocale={isEnglish ? 'en-gb' : currentLanguage}
    >
      <DatePicker
        disabled={disabled}
        data-testid='empion-date-picker'
        name={name}
        slotProps={{textField: {size}}}
        value={dayjs(value)}
        onChange={(date: any) => {
          if (date && date.isValid()) {
            setFieldValue(name, date.format('YYYY-MM-DD'));
          }
        }}
        label={label ? label : ''}
        sx={{
          mb: sx ? 0 : 4,
          width: '100%',
          '& .MuiFormLabel-root.Mui-error': {
            color: theme.palette.text.primary,
          },
          '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: orangeColors[100],
          },
          ...style,
        }}
        disablePast
      />
    </LocalizationProvider>
  );
};
